module.exports = __webpack_public_path__ + "img/djj.61dd6ac0.png";